export default __webpack_public_path__ + "static/media/habib.300ae490.jpeg";